var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu"},[_c('router-link',{attrs:{"to":"/"}},[_c('i18n',{attrs:{"phrase":"menu_clients"}})],1),_c('router-link',{attrs:{"to":"/driver"}},[_c('i18n',{attrs:{"phrase":"menu_drivers"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }